import React, { useEffect } from "react";
import "./Preloader.css";

const Preloader = () => {
  useEffect(() => {
    const timer = setTimeout(() => {
      document.body.classList.add("loaded");
    }, 200);

    return () => {
      clearTimeout(timer);
      document.body.classList.remove("loaded");
    };
  }, []);

  return (
    <div className="content">
      <div className="loader-wrapper">
        <div className="loader"></div>

        <div className="loader-section section-left"></div>
        <div className="loader-section section-right"></div>
      </div>
    </div>
  );
};

export default Preloader;